import { DeepKeys } from "shared/types/deepkeys";
export interface PillarTableExportToExcelDynamicColumnProps<T> {
  valueProperty?: DeepKeys<T>;
  header: string;
  dynamicHeader?: (relativePosition: number, data: T[]) => string | string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?:
    | ((item: any) => string)
    | ((row: T, data: T[]) => string | string[]);
}
const PillarTableExportToExcelDynamicColumn = <T,>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  props: PillarTableExportToExcelDynamicColumnProps<T>,
) => {
  return <></>;
};

export default PillarTableExportToExcelDynamicColumn;
